import React, { useEffect, useState } from "react";
import OurLayouts from "../layout";
import axios from "axios";
import { toast } from "react-toastify";

const CATEGORY_TYPE_OPTIONS = [
  { label: "Hospital", value: "HOSPI360" },
  { label: "Clinic", value: "SC" },
  { label: "Backoffice", value: "BOC" },
];

const AdminOnboarding = () => {
  const [formData, setFormData] = useState({
    // userId: "",
    firstName: "",
    middleName: "",
    lastName: "",
    mobile: "",
    email: "",
    roles: ["ADMIN"],
    password: "",
    active: true,
    tenantId: "",
    categoryType: "",
  });

  const [errors, setErrors] = useState({
    // userId: "",
    firstName: "",
    middleName: "",
    lastName: "",
    mobile: "",
    email: "",
    tenantId: "",
    categoryType: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [users, setUsers] = useState([]);
  const [userIdSuggestions, setUserIdSuggestions] = useState([]);

  const token = localStorage.getItem("auth_token");
  const API_BASE = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await fetch(`${API_BASE}auth/fetch-user-details`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        setUsers(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Failed to fetch users:", error);
      }
    };
    fetchUsers();
  }, [API_BASE, token]);

  const generateUserIdSuggestions = (firstName, mobile, existingUserIds) => {
    const suggestions = [];
    if (firstName && mobile && mobile.length >= 4) {
      const firstKeepCaseNoSpaces = String(firstName).replace(/\s+/g, "");
      const last4 = mobile.substring(mobile.length - 4);
      const candidate = `${firstKeepCaseNoSpaces}_Admin${last4}`;
      if (!existingUserIds.map((x) => String(x).toLowerCase()).includes(candidate.toLowerCase())) {
        suggestions.push(candidate);
      }
    }
    return suggestions;
  };

  const isAlreadyAdmin = async (field, value) => {
    if (!value) return false;
    try {
      const res = await axios.get(`${API_BASE}auth/fetch-user-details`, {
        params: { [field]: value },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = Array.isArray(res.data) ? res.data : [];
      return data.some((u) => Array.isArray(u?.roles) && u.roles.includes("ADMIN"));
    } catch (error) {
      console.error(`Failed to check existing ${field}:`, error.response || error);
      return false;
    }
  };

  const buildBaseSuggestion = (firstName, mobile) => {
    if (firstName && mobile && mobile.length >= 4) {
      const firstKeepCaseNoSpaces = String(firstName).replace(/\s+/g, "");
      const last4 = mobile.substring(mobile.length - 4);
      return `${firstKeepCaseNoSpaces}_Admin${last4}`;
    }
    return "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let filtered = value;
    if (name === "firstName" || name === "middleName" || name === "lastName") {
      filtered = value.replace(/[^a-zA-Z\s]/g, "");
    } else if (name === "mobile") {
      filtered = value.replace(/\D/g, "");
    } else if (name === "tenantId") {
      // Allow only letters, no spaces or dots
      filtered = value.replace(/[^A-Za-z]/g, "");
    }
    setFormData((prev) => ({ ...prev, [name]: filtered }));

    // Suggestions when userId duplicates
    // if (name === "userId" && filtered.trim()) {
    //   const existingUserIds = users.map((u) => String(u.userId || "").toLowerCase());
    //   if (existingUserIds.includes(filtered.toLowerCase())) {
    //     setUserIdSuggestions(
    //       generateUserIdSuggestions(formData.firstName, formData.mobile, existingUserIds)
    //     );
    //   } else {
    //     setUserIdSuggestions([]);
    //   }
    // } 
    // else if (name === "userId") {
    //   setUserIdSuggestions([]);
    // }

    validateField(name, filtered);
  };

  const validateField = (fieldName, value) => {
    let error = "";
    switch (fieldName) {
      // case "userId": {
      //   if (!value.trim()) error = "User ID is required";
      //   else {
      //     const existingUserIds = users.map((u) => String(u.userId || "").toLowerCase());
      //     if (existingUserIds.includes(value.toLowerCase())) {
      //       const suggestions = generateUserIdSuggestions(
      //         formData.firstName,
      //         formData.mobile,
      //         existingUserIds
      //       );
      //       error = suggestions.length > 0
      //         ? `User ID exists. Suggested: ${suggestions[0]}`
      //         : "User ID already exists. Try a different one.";
      //     }
      //   }
      //   break;
      // }
      case "firstName": {
        if (!value.trim()) error = "First name is required";
        else if (!/^[a-zA-Z\s]+$/.test(value.trim())) error = "Only letters and spaces";
        break;
      }
      case "middleName": {
        if (value.trim() && !/^[a-zA-Z\s]+$/.test(value.trim())) error = "Only letters and spaces";
        break;
      }
      case "lastName": {
        if (value.trim() && !/^[a-zA-Z\s]+$/.test(value.trim())) error = "Only letters and spaces";
        break;
      }
      case "mobile": {
        if (!value.trim()) error = "Mobile number is required";
        else if (!/^\d{10}$/.test(value)) error = "Enter valid 10-digit number";
        break;
      }
      case "email": {
        if (!value.trim()) error = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) error = "Enter a valid email";
        break;
      }
      case "tenantId": {
        if (!value.trim()) error = "Tenant ID is required";
        else if (!/^[A-Za-z]+$/.test(value)) error = "Only letters";
        break;
      }
      case "categoryType": {
        if (!value) error = "Category type is required";
        break;
      }
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [fieldName]: error }));
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      // userId: "",
      firstName: "",
      middleName: "",
      lastName: "",
      mobile: "",
      email: "",
      tenantId: "",
      categoryType: "",
    };

    // if (!formData.userId.trim()) {
    //   newErrors.userId = "User ID is required";
    //   valid = false;
    // } else {
    //   const existingUserIds = users.map((u) => String(u.userId || "").toLowerCase());
    //   if (existingUserIds.includes(formData.userId.toLowerCase())) {
    //     const suggestions = generateUserIdSuggestions(formData.firstName, formData.mobile, existingUserIds);
    //     newErrors.userId = suggestions.length > 0
    //       ? `User ID exists. Suggested: ${suggestions[0]}`
    //       : "User ID already exists. Try a different one.";
    //     valid = false;
    //   }
    // }

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
      valid = false;
    } else if (!/^[a-zA-Z\s]+$/.test(formData.firstName.trim())) {
      newErrors.firstName = "Only letters and spaces";
      valid = false;
    }

    if (formData.middleName.trim() && !/^[a-zA-Z\s]+$/.test(formData.middleName.trim())) {
      newErrors.middleName = "Only letters and spaces";
      valid = false;
    }

    if (formData.lastName.trim() && !/^[a-zA-Z\s]+$/.test(formData.lastName.trim())) {
      newErrors.lastName = "Only letters and spaces";
      valid = false;
    }

    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
      valid = false;
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Enter valid 10-digit number";
      valid = false;
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email";
      valid = false;
    }

    if (!formData.tenantId.trim()) {
      newErrors.tenantId = "Tenant ID is required";
      valid = false;
    } else if (!/^[A-Za-z]+(?:[A-Za-z]*\.)*[A-Za-z]+$/.test(formData.tenantId)) {
      newErrors.tenantId = "Use letters and dots only (e.g., SparshClinicPvt.Ltd)";
      valid = false;
    }

    if (!formData.categoryType) {
      newErrors.categoryType = "Category type is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    if (!validateForm()) {
      setIsSubmitting(false);
      return;
    }

    const [emailIsAdmin, mobileIsAdmin] = await Promise.all([
      isAlreadyAdmin("email", formData.email),
      isAlreadyAdmin("mobile", formData.mobile),
    ]);

    if (emailIsAdmin) {
      toast.error("This email is already registered as an Admin.");
      setIsSubmitting(false);
      return;
    }
    if (mobileIsAdmin) {
      toast.error("This mobile number is already registered as an Admin.");
      setIsSubmitting(false);
      return;
    }

    try {
      const firstResponse = await axios.post(`${API_BASE}auth/register`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
         
        },
      });

      if (firstResponse.status === 200) {
        try {
          const payloadWithId = {
            ...formData,
            userId: firstResponse?.data?.data,
          };
          const secondResponse = await axios.post(`${API_BASE}auth/register`, payloadWithId, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
              tenantId: formData.tenantId,
            },
          });
    
          if (secondResponse.status === 200) {
            toast.success("Admin onboarded successfully");
            
          }
    
          setFormData({
            // userId: "",
            firstName: "",
            middleName: "",
            lastName: "",
            mobile: "",
            email: "",
            roles: ["ADMIN"],
            password: "",
            active: true,
            tenantId: "",
            categoryType: "",
          });
          setErrors({
            // userId: "",
            firstName: "",
            middleName: "",
            lastName: "",
            mobile: "",
            email: "",
            tenantId: "",
            categoryType: "",
          });
          setUserIdSuggestions([]);
        } catch (err) {
          console.error("Admin onboarding error:", err.response || err);
          const errorMessage =
            err.response?.data?.error || err.response?.data?.message || "Failed to onboard admin. Please try again.";
          toast.error(errorMessage);
        } 
        
      }

     
    } catch (err) {
      console.error("Admin onboarding error:", err.response || err);
      const errorMessage =
        err.response?.data?.error || err.response?.data?.message || "Failed to onboard admin. Please try again.";
      toast.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <OurLayouts>
      <div className="w-full mx-auto bg-[#f1f8f7] p-6 rounded-lg shadow-md mt-10 max-w-4xl">
        <h1 className="text-2xl font-bold text-[#004276] mb-6">Onboard Admin</h1>

        <form onSubmit={handleSubmit} noValidate>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* <div className="mb-4">
              <label className="block text-[#004276] font-medium mb-2" htmlFor="userId">
                User ID *
              </label>
              <input
                type="text"
                id="userId"
                name="userId"
                placeholder="firstname@last4digits"
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                  errors.userId ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                }`}
                value={formData.userId}
                onChange={handleChange}
              />
              {errors.userId && <p className="mt-1 text-sm text-red-600">{errors.userId}</p>}
              {userIdSuggestions.length > 0 && (
                <div className="mt-2 flex items-center gap-2">
                  <span className="text-sm text-gray-600">Suggestion:</span>
                  <button
                    type="button"
                    className="text-sm px-2 py-1 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-800"
                    onClick={() => {
                      const suggestion = userIdSuggestions[0];
                      setFormData((prev) => ({ ...prev, userId: suggestion }));
                      setErrors((prev) => ({ ...prev, userId: "" }));
                    }}
                  >
                    {userIdSuggestions[0]}
                  </button>
                </div>
              )}
            </div> */}

            <div className="mb-4">
              <label className="block text-[#004276] font-medium mb-2" htmlFor="firstName">
                First Name *
              </label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                placeholder="Enter first name"
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                  errors.firstName ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                }`}
                value={formData.firstName}
                onChange={handleChange}
              />
              {errors.firstName && <p className="mt-1 text-sm text-red-600">{errors.firstName}</p>}
            </div>

            <div className="mb-4">
              <label className="block text-[#004276] font-medium mb-2" htmlFor="middleName">
                Middle Name
              </label>
              <input
                type="text"
                id="middleName"
                name="middleName"
                placeholder="Enter middle name"
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                  errors.middleName ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                }`}
                value={formData.middleName}
                onChange={handleChange}
              />
              {errors.middleName && <p className="mt-1 text-sm text-red-600">{errors.middleName}</p>}
            </div>

            <div className="mb-4">
              <label className="block text-[#004276] font-medium mb-2" htmlFor="lastName">
                Last Name
              </label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                placeholder="Enter last name"
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                  errors.lastName ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                }`}
                value={formData.lastName}
                onChange={handleChange}
              />
              {errors.lastName && <p className="mt-1 text-sm text-red-600">{errors.lastName}</p>}
            </div>

            <div className="mb-4">
              <label className="block text-[#004276] font-medium mb-2" htmlFor="mobile">
                Mobile *
              </label>
              <input
                type="tel"
                id="mobile"
                name="mobile"
                placeholder="Enter mobile number"
                maxLength="10"
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                  errors.mobile ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                }`}
                value={formData.mobile}
                onChange={handleChange}
              />
              {errors.mobile && <p className="mt-1 text-sm text-red-600">{errors.mobile}</p>}
            </div>

            <div className="mb-4">
              <label className="block text-[#004276] font-medium mb-2" htmlFor="email">
                Email *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter email"
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                  errors.email ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                }`}
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email}</p>}
            </div>

            <div className="mb-4">
              <label className="block text-[#004276] font-medium mb-2" htmlFor="tenantId">
                Tenant ID *
              </label>
              <input
                type="text"
                id="tenantId"
                name="tenantId"
                placeholder="e.g., SparshClinicPvt.Ltd"
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                  errors.tenantId ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
                }`}
                value={formData.tenantId}
                onChange={handleChange}
              />
              {errors.tenantId && <p className="mt-1 text-sm text-red-600">{errors.tenantId}</p>}
            </div>

            <div className="mb-4">
              <label className="block text-[#004276] font-medium mb-2" htmlFor="categoryType">
                Category Type *
              </label>
              <select
                id="categoryType"
                name="categoryType"
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 bg-white ${
                  errors.categoryType
                    ? "border-red-500 focus:ring-red-500"
                    : "border-gray-300 focus:ring-blue-500"
                }`}
                value={formData.categoryType}
                onChange={handleChange}
              >
                <option value="">Select category type</option>
                {CATEGORY_TYPE_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {errors.categoryType && (
                <p className="mt-1 text-sm text-red-600">{errors.categoryType}</p>
              )}
            </div>
          </div>

          <div className="flex justify-end space-x-4 mt-6">
            <button
              type="button"
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              onClick={() => {
                setFormData({
                  // userId: "",
                  firstName: "",
                  middleName: "",
                  lastName: "",
                  mobile: "",
                  email: "",
                 roles: ["ADMIN"],
                  password: "",
                  active: true,
                  tenantId: localStorage.getItem("tenantId") || "",
                  categoryType: "",
                });
                setErrors({
                  // userId: "",
                  firstName: "",
                  middleName: "",
                  lastName: "",
                  mobile: "",
                  email: "",
                  tenantId: "",
                  categoryType: "",
                });
                setUserIdSuggestions([]);
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`px-4 py-2 bg-gradient-to-r from-[#004172] to-[#3cba84] text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                isSubmitting ? "opacity-70 cursor-not-allowed" : "hover:opacity-90"
              }`}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Processing..." : "Onboard Admin"}
            </button>
          </div>
        </form>
      </div>
    </OurLayouts>
  );
};

export default AdminOnboarding;


